import { Pipe, PipeTransform } from '@angular/core';
import { DateFormatT, DateTimeFormatService } from 'app/shared/services/date-time-format/date-time-format.service';
import { LocalizedDatePipe } from '../localized-date-pipe/localized-date-pipe.pipe';

@Pipe({
    name: 'dateTimeFormatPipe',
    pure: false,
    standalone: false
})

export class DateTimeFormatPreferencePipe implements PipeTransform {
  constructor(
    private dateTimeFormatService: DateTimeFormatService,
    private dp: LocalizedDatePipe,
  ) {
  }

  transform(value: Date | number | string, toShow: string, timezone?:string, extraPattern?:string): string {
    return this.dp.transform(value, this.dateTimeFormatService.getDateFormat(toShow as DateFormatT),timezone,extraPattern);
  }
}
